export default {
  bugReportDialog: (state) => { return state.bugReportDialog }
};